import { useRouterState } from "@tanstack/react-router";
import { useTranslate } from "@tolgee/react";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { syncDocumentSeo } from "#/lib/seo";
import { learnSeoAtom } from "#/stores/learn-seo-store";
import { localeAtom } from "#/stores/locale-store";

export function SeoSync() {
	const locale = useAtomValue(localeAtom);
	// learn 글 데이터가 도착하면(learn-article-page가 atom에 게시) 재동기화 —
	// head 기록자는 여기 하나뿐이다.
	const learnSeo = useAtomValue(learnSeoAtom);
	const { t } = useTranslate();
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	useEffect(() => {
		syncDocumentSeo({
			locale,
			pathname,
			t,
			learnSeo,
		});
	}, [locale, pathname, t, learnSeo]);

	return null;
}
